module.exports = __webpack_public_path__ + "static/fonts/montserrat-v29-cyrillic_cyrillic-ext_latin_latin-ext-italic.4569baf.woff2";